import Flow from "./components/Flow";
import { ReactFlowProvider } from "reactflow";

import "reactflow/dist/style.css";
const DesignApprovalProcessDetail = ({ translate }) => (
  <ReactFlowProvider>
    <Flow translate={translate} />
  </ReactFlowProvider>
);

export default DesignApprovalProcessDetail;
